<div class="container" style="margin-top: 100px;">

        <div class="row justify-content-center">
                <div class="col-sm-6">
                        <h2 class="h2">Create a new account, It's free</h2>
                        <h4 class="display-1 text-center bg-primary"
                                style="border:1px solid grey;border-radius: 10px;line-height: 50px;color:white">Sign In
                        </h4>
                        <div class="form-group">
                                <form [formGroup]="signupform" (ngSubmit)="signUp()">
                                        Username : <input type="text" id="Username" formControlName="Username" placeholder="Enter your username"
                                                class="form-control" />
                                                <br>
                                        <div *ngIf="Username.invalid && (Username.dirty || Username.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="Username.errors.required">
                                                        Username is required.
                                                </div>
                                                <div *ngIf="Username.errors.minlength">
                                                        Username must be at least 4 characters long.
                                                </div>
                                        </div>
                                        Email : <input type="email" formControlName="Email" class="form-control" placeholder="Enter your email" /><br>
                                        <div *ngIf="Email.invalid && (Email.dirty || Email.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="Email.errors.required">
                                                        Email is required.
                                                </div>
                                                <div *ngIf="Email.errors.email">
                                                        Email should be valid.
                                                </div>
                                                <div *ngIf="Email.errors.minlength">
                                                        Email must be at least 4 characters long.
                                                </div>
                                        </div>
                                        Password : <input type="password" formControlName="Password"
                                                class="form-control" placeholder="Enter your password" /><br>
                                        <div *ngIf="Password.invalid && (Password.dirty || Password.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="Password.errors.required">
                                                        Password is required.
                                                </div>
                                                <div *ngIf="Password.errors.minlength">
                                                        Password must be at least 8 characters long.
                                                </div>
                                        </div>
                                        Phone : <input type="ngSubmit" formControlName="PhoneNumber"
                                                class="form-control" placeholder="Enter your phone number" /><br>
                                        <div *ngIf="PhoneNumber.invalid && (PhoneNumber.dirty || PhoneNumber.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="PhoneNumber.errors.required">
                                                        PhoneNumber is required.
                                                </div>
                                                <div *ngIf="PhoneNumber.errors.minlength">
                                                        PhoneNumber must be at least 10 characters long.
                                                </div>
                                        </div>
                                        <button type="submit" class="btn btn-primary" [disabled]="!signupform.valid">Sign Me Up</button>
                                </form>
                        </div>